<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" lg="12">
                <v-card flat outlined>
                    <v-card-title>
                        {{ $t('labels.placements') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :default-sort="placementsTable.defaultSort"
                                    :excel="false"
                                    :fields="placementsTable.headers"
                                    :header-selection-key="'seafarer-placements-headers'"
                                    :total-records="placementsTable.total"
                                    :filter-save-key="'seafarer-placements-filters'"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                    height="300px"
                                >
                                    <tr
                                        v-for="(item, key) in placementsTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(item.id, true)"
                                    >
                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('id')"
                                            class="text-right"
                                            @click="editClick(item.id, true)"
                                        >
                                            {{ item.id }}
                                        </td>
                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('seafarer')"
                                            @click="editClick(item.id, true)"
                                        >
                                            {{ item.seafarer_display }}
                                        </td>
                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('rank')"
                                            @click="editClick(item.id, true)"
                                        >
                                            {{ item.rank_display }}
                                        </td>
                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('maritime_object')"
                                            @click="editClick(item.id, true)"
                                        >
                                            {{ item.maritime_object_display }}
                                        </td>
                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('vessel_type')"
                                            @click="editClick(item.id, true)"
                                        >
                                            {{ item.vessel_type_display }}
                                        </td>
                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('sign_on_date')"
                                            @click="editClick(item.id, true)"
                                        >
                                            {{ item.sign_on_date_display }}
                                        </td>
                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('sign_off_date')"
                                            @click="editClick(item.id, true)"
                                        >
                                            {{ item.sign_off_date_display }}
                                        </td>
                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('placement_status')"
                                            @click="editClick(item.id, true)"
                                        >
                                            {{ item.placement_status_display }}
                                        </td>
                                        <td class="text-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="editClick(item.id, true)"
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-external-link-alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.openInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'SeafarerPlacements',
    components: {TheTable},
    data: function () {
        return {
            placementsTable: {
                selectedHeaders: [],
                headers: [
                    {text: this.$t('fields.id'), value: 'id', type: '', sortable: false, width: '10%'},
                    {text: this.$t('fields.seafarer'), value: 'seafarer', type: '', sortable: false},
                    {text: this.$t('fields.rank'), value: 'rank', type: '', sortable: false},
                    {text: this.$t('fields.maritimeObject'), value: 'maritime_object', type: '', sortable: false},
                    {text: this.$t('fields.vesselType'), value: 'vessel_type', type: '', sortable: false},
                    {text: this.$t('fields.signOnDate'), value: 'sign_on_date', type: '', sortable: false},
                    {text: this.$t('fields.signOffDate'), value: 'sign_off_date', type: '', sortable: false},
                    {
                        text: this.$t('fields.status'),
                        value: 'placement_status',
                        type: '',
                        width: '150px',
                        sortable: false,
                    },
                    {text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false},
                ],
                additionalFilters: [],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'id',
                    descending: true,
                },
            },
        };
    },
    props: ['seafarer'],
    methods: {
        editClick(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/placements/' + id);
            } else {
                let routeData = this.$router.resolve('/placements/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        selectHeaders(headers) {
            this.placementsTable.selectedHeaders = headers;
        },
        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall('get', 'seafarer-placements/' + this.seafarer.id, request, (data, success) => {
                if (success) {
                    vm.placementsTable.items = data.items;
                    vm.placementsTable.total = data.total;
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'placements',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/placements', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        resolveWindowResize() {
            this.placementsTable.height = window.innerHeight - 310 + 'px';
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
};
</script>

<style scoped></style>
